module.exports = __webpack_public_path__ + "img/mockup-sw-ncy.ff6119e.jpeg";